<!-- bg-gray-50 background colo applied before -->
<!-- text-gray-600 used in all fonts except headers -->
<footer class="bg-gradient-to-r from-orange-500 to-red-500 border-t border-gray-200">

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div class="grid grid-cols-1 gap-0 md:grid-cols-[40%_20%_20%_20%] md:gap-2">
      <!-- Company Info -->
      <div class="col-span-1">
        <div class="flex items-center space-x-2 mb-4">
          <!-- <div class="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center shadow-lg">
                <span class="text-white font-bold text-lg">CF</span>
              </div>
              <div>
                <h3 class="text-xl font-bold text-gray-900">Capital</h3>
                <p class="text-xs text-gray-600 font-semibold -mt-1">FOOD</p>
              </div> -->
          <div>
            <!-- text-gray-700 is used below heading -->
            <h3 class="text-xl font-bold text-white">Capital Food Products</h3>
          </div>
        </div>
        <p class="text-white text-sm leading-relaxed mb-4">
          {{ companyInfo.description }}
        </p>
        <!-- text-gray-700 is used below paragraph -->
        <p class="text-white text-sm font-medium">
          {{ companyInfo.motto }}
        </p>
      </div>

      <!-- Company Links -->
      <div class="mb-1 md:mb-0 md:pl-10 w-50%">
        <!-- <h4 class="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Company</h4> -->
        <ul class="space-y-3 mt-5 md:mt-10">
          <!-- Used below links hover:text-gray-600 -->
          <li><a routerLink="/contact"
              class="text-white hover:text-gray-600 text-sm transition-colors text-center">Contact Us</a></li>
          <!-- <li><a routerLink="/about" class="text-white hover:text-gray-600 text-sm transition-colors">About Us</a></li>
              <li><a routerLink="/careers" class="text-white hover:text-gray-600 text-sm transition-colors">Careers</a></li>
              <li><a routerLink="/blog" class="text-white hover:text-gray-600 text-sm transition-colors">Blog</a></li> -->
        </ul>
      </div>

      <!-- Get Help Links -->
      <div>
        <!-- <h4 class="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Get Help</h4> -->
        <ul class="space-y-1 md:space-y-3 mt-0 md:mt-10">
          <!-- <li><a routerLink="/contact" class="text-white hover:text-gray-600 text-sm transition-colors">Contact Us</a></li> -->
          <!-- <li><a routerLink="/faq" class="text-white hover:text-gray-600 text-sm transition-colors">Help & Support</a></li> -->
          <li><a routerLink="/delivery-policy" class="text-white hover:text-gray-600 text-sm transition-colors">Delivery
              Policies</a></li>
          <li><a routerLink="/privacy-policy" class="text-white hover:text-gray-600 text-sm transition-colors">Privacy
              Policies</a></li>
          <li><a routerLink="/terms" class="text-white hover:text-gray-600 text-sm transition-colors">Terms &
              Conditions</a></li>
        </ul>
      </div>

      <!-- Explore Links -->
      <div>
        <!-- <h4 class="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Explore</h4> -->
        <ul class="space-y-1 md:space-y-3 mt-0 md:mt-10">
          <!-- <li><a routerLink="/offers" class="text-white hover:text-gray-600 text-sm transition-colors">Offers</a></li> -->
          <li><a routerLink="/bulk-order" class="text-white hover:text-gray-600 text-sm transition-colors">Bulk
              Order</a></li>
          <li><a routerLink="/partner" class="text-white hover:text-gray-600 text-sm transition-colors">Partner with
              Us</a></li>
        </ul>
      </div>
    </div>

    <!-- Bottom Section -->
    <div class="mt-12 pt-8 border-t border-gray-200">
      <div class="flex flex-col md:flex-row justify-between items-center">
        <!-- text-gray-500 is used below paragraph -->
        <p class="text-white text-sm">
          Copyright 2020 - 2025. Capital Food Products. All rights reserved.
        </p>
        <div class="flex items-center space-x-4 mt-4 md:mt-0">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
            class="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:bg-[#1877F2] hover:text-white transition-all">
            <lucide-icon name="facebook" class="w-5 h-5"></lucide-icon>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
            class="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:bg-black hover:text-white transition-all">
            <!-- <lucide-icon name="twitter" class="w-5 h-5"></lucide-icon> -->
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
            class="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:bg-gradient-to-r hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] hover:text-white transition-all">
            <lucide-icon name="instagram" class="w-5 h-5"></lucide-icon>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"
            class="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:bg-[#FF0000] hover:text-white transition-all">
            <lucide-icon name="youtube" class="w-5 h-5"></lucide-icon>
          </a>
        </div>
      </div>



    </div>
    <!-- <div>
      <p style="margin: 0;text-align: center;">
        <span class="bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">{{visitors}}</span>
      </p>
    </div> -->
    <div class="bg-gradient-to-r from-orange-500 to-red-500 mb-2">
      <p class="m-0 text-center mix-blend-screen">
        {{visitors}}
      </p>
    </div>
  </div>
</footer>